import * as types from './types';

const getPostingContactData = postingId => {
  return {
    type: types.GET_POSTING_CONTACT_DATA,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/getContactDataSource`,
      method: 'GET',
      query: { postingId }
    }
  };
};

const updateUserResponsibleForPosting = (postingId, userId, deletePostingPhone = false) => {
  return {
    type: types.UPDATE_USER_RESPONSIBLE_FOR_POSTING,
    meta: {
      async: true,
      blocking: false,
      api: 'avisos',
      path: `/panel/api/v2/postings/updatePostingResponsible`,
      method: 'PUT',
      query: { postingId, userId, deletePostingPhone }
    }
  };
};

export { getPostingContactData, updateUserResponsibleForPosting };
